<template lang="pug">
  v-row(no-gutters)
    v-col(cols=12)
      v-card.toolbartab
        v-toolbar.toolbartab.mt-10(dark flat)
          h2 {{ $t('add-credit') }}
        v-progress-linear(
          color='light-green'
          height='10'
          :value='progressValue'
          striped
        )
        v-row.py-3(no-gutters justify="center")
          v-col(
            v-for='(item,i) in progressName'
            :key='i'
            align="center"
          )
            v-avatar(:color='item.color', size='30')
              span.white--text.headline {{ i+1 }}
            h4.white--text  {{ $t(item.name) }}
    v-col(cols=12)
      creating-channel.mt-3(v-if='retryLoading' :countdown='retryCountdown')
      bankpage(v-else-if='status1' :on-submit-loading='onSubmitLoading' @submit='requestTopupSubmit' @nextPage='status1change' @preset-gate-payment="showPresetGatePayment")
      payment(v-else-if='status2' :bank-info='bank' @next='status2change' @cancel='backToSelectBank' @preset-gate-slip="submitPresetGateSlip")
      success(v-else-if='status3')
    v-col(cols=12).mt-4
      promotion
    dialog-promotion-lock(ref='dialogPromotionLockRef')

</template>
<script> 
import { credits as apiCredits, users as apiUsers } from '@/apis' 
import bankpage from '@/views/Deposit/childs/selectBankPage.vue'
import payment from '@/views/Deposit/childs/payment.vue'
import success from '@/views/Deposit/childs/success.vue'
import promotion from '@/views/Deposit/childs/promotion.vue'
import creatingChannel from '@/views/Deposit/childs/creatingChannel.vue'
import DialogPromotionLock from '@/components/Promotion/DialogPromotionLock'

const LINK_DEEP_CODE = 46
const WORLDPAY = 52
const PRIME_PAY = 58
const AUTOPEER = 65
const RETRY_CHANNELS = [LINK_DEEP_CODE, WORLDPAY, PRIME_PAY, AUTOPEER]
const RETRY_TOTAL_SECONDS = 180
const RETRY_INTERVAL_SECONDS = 5

export default {
  components:{
    bankpage,
    success,
    payment,
    promotion,
    creatingChannel,
    DialogPromotionLock,
  },  
  data: () => ({
    status1:true,
    status2:false,
    status3:false,
    progressName : [
        { name:'channel-payment',color:'var(--bg-secondary-color)' },
        {name:'payment',color:'grey'},
        {name:'success',color:'grey'}, ],
    progressValue : '10',  
    bank : null,
    amount :null,
    onSubmitLoading: false,
    retryLoading: false,
    retryCountdown: 0,
  }),
  beforeDestroy () {
    this.cancelTopupRetry()
  },
  methods : {
    reqirectTo (to) {
      window.location.href = `${to}`
    },

    async requestTopupSubmit (bank, amount, qr) {
      let params =  {
        admin_bank_uuid : bank.uuid,
        request_amount : amount,
        request_qr_string: qr,
      }

      params = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v != null)
      )

      this.onSubmitLoading = true;

      let [err,data,,,status] = await apiCredits.topup(params)

      this.onSubmitLoading = false;

      if (status == 409) {
        this.requestVerifyDemo()
        return
      }

      if (status == 423) {
        this.$refs.dialogPromotionLockRef.open()
        return
      }

      const isRetryChannel = RETRY_CHANNELS.includes(bank && bank.bank_type && bank.bank_type.id)

      if (isRetryChannel && (err || !data)) {
        const result = await this.startTopupRetry(params)

        if (result.type === 'cancelled') {
          return
        }

        if (result.type === 'timeout') {
          this.$alert('', 'กรุณาลองใหม่อีกครั้ง', 'warning')
          return
        }

        const [rErr, rData] = result.res
        err = rErr
        data = rData
      }

      if(err) {
        this.$alert('',err,'warning')
        return
      }

      if(!data) {
        return
      }

      if (qr) {
        this.$alert('อยู่ระหว่างเจ้าหน้าที่ตรวจสอบ กรณีที่ยอดเงินไม่ปรับ กรุณาติดต่อเจ้าหน้าที่', 'ดำเนินการสำเร็จ', 'success').then(() => {
          location.reload();
        });
        
        return
      }

      if (data.redirect_to) {
        this.reqirectTo(data.redirect_to)
        return
      }

      let bankValue = {
          pg_bank_type_id : bank.bank_type?.id,
          redirect_to : data.redirect_to,
          status : data.status,
          expire_in : data.expire_in,
          created_at : data.created_at,
          user_bank_number : data.user_bank_number,
          user_bank_name : data.user_bank_name,
          ref_id : data.ref_id,
          uuid : data.uuid,
          request_description : data.request_description,
          request_confirmed_at : data.request_confirmed_at,
          verifier_admin_description : data.verifier_admin_description,
          verified_at : data.verified_at,
          admin_bank: {
            bank_type : data.admin_bank.bank_type || bank.bank_type, 
            name : data.admin_bank.name,
            number : data.admin_bank.number,
            uuid : bank.uuid,
            description : bank.description,
            amount_limit : bank.amount_limit || 0,
            qr_image_url: data.admin_bank.qr_image_url,
          },
          request_amount : data.request_amount
      }
      this.amount = data.request_amount
      this.status1change(bankValue) 
    },
    async requestVerifyDemo () {
      const [err,data] = await apiUsers.getDemoUserVerify()

      if(err) { 
        this.$alert('',err,'warning')  
        return
      }  

      this.$alert('',data,'success')
    },
    startTopupRetry (params) {
      return new Promise((resolve) => {
        this.retryLoading = true
        this.retryCountdown = RETRY_TOTAL_SECONDS

        const cleanup = () => {
          if (this._retryCountdownTimer) {
            clearInterval(this._retryCountdownTimer)
            this._retryCountdownTimer = null
          }
          if (this._retryPollTimer) {
            clearInterval(this._retryPollTimer)
            this._retryPollTimer = null
          }
          this._retrySettle = null
          this.retryLoading = false
        }

        this._retrySettle = (result) => {
          cleanup()
          resolve(result)
        }

        this._retryCountdownTimer = setInterval(() => {
          this.retryCountdown -= 1
          if (this.retryCountdown <= 0 && this._retrySettle) {
            this._retrySettle({ type: 'timeout' })
          }
        }, 1000)

        this._retryPollTimer = setInterval(async () => {
          if (this._retryInFlight || !this._retrySettle) {
            return
          }

          this._retryInFlight = true
          const res = await apiCredits.topup(params)
          this._retryInFlight = false

          if (!this._retrySettle) {
            return
          }

          const [err, data] = res
          if (!err && data) {
            this._retrySettle({ type: 'success', res })
          }
        }, RETRY_INTERVAL_SECONDS * 1000)
      })
    },
    cancelTopupRetry () {
      if (this._retrySettle) {
        this._retrySettle({ type: 'cancelled' })
      }
    },
    status1change (bankValue) {
      this.bank = bankValue
      this.progressValue = '50'
      this.status2 = true
      this.status1 = false
      this.progressName[0].color = 'grey'
      this.progressName[1].color = 'var(--bg-secondary-color)' 
    },
    status2change () {
      this.progressValue = '100'
      this.status3 = true
      this.status2 = false
      this.progressName[1].color = 'grey'
      this.progressName[2].color = 'var(--bg-secondary-color)'
    },
    showPresetGatePayment (bankInfo) {
      this.status1change(bankInfo)
    },
    submitPresetGateSlip ({ uuid, bank_type, qr }) {
      this.requestTopupSubmit({ uuid, bank_type }, null, qr)
    },
    backToSelectBank () {
      this.bank = null
      this.progressValue = '10'
      this.status1 = true
      this.status2 = false
      this.status3 = false
      this.progressName[0].color = 'var(--bg-secondary-color)'
      this.progressName[1].color = 'grey'
      this.progressName[2].color = 'grey'
    }
  }
}
</script> 